
import { defineComponent } from "vue";

// import NavigationMobile from '~/vue/organisms/navigations/NavigationMobile.vue'
// import ButtonToggleMobileNavigation from '~/vue/atoms/buttons/ButtonToggleMobileNavigation.vue'
import CardPrimary from "~/vue/molecules/cards/CardPrimary.vue";
import CardExternalLink from "~/vue/molecules/cards/CardExternalLink.vue";

export default defineComponent({
	components: {
		"card--external-link": CardExternalLink,
		"card--primary": CardPrimary,
		// 'button--toggle-mobile-navigation': ButtonToggleMobileNavigation,
		// 'navigation--mobile': NavigationMobile,
	},
});
